import React, {
  useState
} from "react";

import {
  useDispatch,
  useSelector
} from "react-redux";

import {
  useHistory,
  Link
} from "react-router-dom";

import {
  signupAction,
  sendOtpAction
} from "../../../store/actions/authActions/authActions";
import AuthLayout from "./AuthLayout";

export default function SignupPageNode() {

  const dispatch =
    useDispatch();

  const history =
    useHistory();

  const loading =
    useSelector(
      state =>
        state?.auth?.loading||null
    );

  const [tab, setTab] =
    useState("email");

  const [emailData,
    setEmailData] =
    useState({

      firstName: "",
      lastName: "",

      email: "",
      password: ""

    });

  const [phoneData,
    setPhoneData] =
    useState({

      firstName: "",
      lastName: "",

      phone: ""
    });

  /* =========================
     EMAIL SIGNUP
  ========================= */

  const handleEmailSignup =
    async e => {

      e.preventDefault();

      try {

        const response =
          await dispatch(

            signupAction({

              type: "email",

              firstName:
                emailData.firstName,

              lastName:
                emailData.lastName,

              email:
                emailData.email,

              password:
                emailData.password
            })
          );

        history.push(
          "/crm"
        );

      } catch (error) {

        console.error(
          error
        );
      }
    };

  /* =========================
     PHONE SIGNUP
  ========================= */

  const handlePhoneSignup =
    async e => {

      e.preventDefault();

      try {

        const response =
          await dispatch(

            sendOtpAction({

              phone:
                phoneData.phone,

              purpose:
                "signup"
            })
          );

        localStorage.setItem(

          "pendingSignup",

          JSON.stringify(
            phoneData
          )
        );

        history.push(
          "/verify-otpV2"
        );

      } catch (error) {

        console.error(
          error
        );
      }
    };

  return (

   <AuthLayout

  title="Create Your Account"

  subtitle="Start creating courses, tests and learning experiences in minutes."

>

        <h1>
          Create Account
        </h1>

        {/* =====================
            TABS
        ===================== */}

       <div className="auth-tabs">

  <button
    type="button"
    className={
      tab === "email"
        ? "active"
        : ""
    }
    onClick={() =>
      setTab("email")
    }
  >
    Email
  </button>

  <button
    type="button"
    className={
      tab === "phone"
        ? "active"
        : ""
    }
    onClick={() =>
      setTab("phone")
    }
  >
    Phone
  </button>

</div>

        {/* =====================
            EMAIL SIGNUP
        ===================== */}

        {tab === "email" && (

          <form
            onSubmit={
              handleEmailSignup
            }
          >
            <div>

    <label>
      First Name
    </label>


            <input
              type="text"
              placeholder="First Name"
              value={
                emailData.firstName
              }
              onChange={e =>
                setEmailData({

                  ...emailData,

                  firstName:
                    e.target.value
                })
              }
              required
            />
</div>
            {/* <div className="auth-row">

  
  <div>


    <label>
      Last Name
    </label>

            <input
              type="text"
              placeholder="Last Name"
              value={
                emailData.lastName
              }
              onChange={e =>
                setEmailData({

                  ...emailData,

                  lastName:
                    e.target.value
                })
              }
              required
            />
</div>
</div> */}
<div>
  <div>

    <label>
      Email
    </label>

            <input
              type="email"
              placeholder="Email"
              value={
                emailData.email
              }
              onChange={e =>
                setEmailData({

                  ...emailData,

                  email:
                    e.target.value
                })
              }
              required
            />
</div>

  <div>

    <label>
      Password
    </label>

            <input
              type="password"
              placeholder="Password"
              value={
                emailData.password
              }
              onChange={e =>
                setEmailData({

                  ...emailData,

                  password:
                    e.target.value
                })
              }
              required
            />
            <small>

Minimum 8 characters

</small>
</div></div>
           <button
 className="auth-btn"
 type="submit"
>

 {
  loading
   ? "Creating Account..."
   : "Create My Account"
 }

</button>
          </form>

        )}

        {/* =====================
            PHONE SIGNUP
        ===================== */}

        {tab === "phone" && (

          <form
            onSubmit={
              handlePhoneSignup
            }
          >

  {/* <div>

    <label>
      First Name
    </label>
            <input
              type="text"
              placeholder="First Name"
              value={
                phoneData.firstName
              }
              onChange={e =>
                setPhoneData({

                  ...phoneData,

                  firstName:
                    e.target.value
                })
              }
              required
            />
</div>
  <div>

    <label>
      Last Name
    </label>
            <input
              type="text"
              placeholder="Last Name"
              value={
                phoneData.lastName
              }
              onChange={e =>
                setPhoneData({

                  ...phoneData,

                  lastName:
                    e.target.value
                })
              }
              required
            />
</div> */}

  <div>

    <label>
      Phone Number
    </label>
            <input
              type="text"
              placeholder="Phone Number"
              value={
                phoneData.phone
              }
              onChange={e =>
                setPhoneData({

                  ...phoneData,

                  phone:
                    e.target.value
                })
              }
              required
            />
            </div>
      <p className="auth-help">

  We'll send a one-time verification code.

</p>
           <button
 className="auth-btn"
 type="submit"
>

 {
  loading
   ? "Sending OTP..."
   : "Send Verification Code"
 }

</button>

          </form>

        )}

        {/* =====================
            LINKS
        ===================== */}

        <div className="auth-footer">

  Already have an account?

  <Link to="/loginV2">

    Sign In

  </Link>

</div>
</AuthLayout>
  );
}